<template>
  <v-container>
    <v-fade-transition mode="out-in">
      <a-authorization-card
        v-if="!erreur"
        class="ma-5"
        color="secondary"
        icon="mdi-arrow-decision"
        title="Finalisation de la connexion"
        text="Récupération des informations d'authentification en cours."
        sub="Cela peut prendre quelques instants."
      />
      <a-authorization-card
        v-else
        class="ma-5"
        color="error"
        icon="mdi-account-alert-outline"
        title="Erreur lors de l'authentification"
        text="Oups... quelque chose s'est mal passé lors de votre authentification."
        sub="Vous devriez rééssayer."
      />
    </v-fade-transition>
  </v-container>
</template>

<script>
import { oauth2Service, principalService } from "@/services";
import makeFields from "@/mixins/makeFields";

export default {
  data() {
    return {
      erreur: false,
    };
  },

  mounted() {
    const url = window.location.search;

    //suppression des paramètres state et code de l'URL
    window.history.replaceState({}, {}, "/accueil");

    oauth2Service
      .processCallbackUrl(url)
      .then(() => principalService.principal())
      .then(principal => {
        this.$store.commit("utilisateur/login", principal);
        const to = this.redirectTo;
        this.$router.push(to || "/accueil").catch();
      })
      .catch(() => {
        this.erreur = true;
        oauth2Service.logout();
      });
  },
  computed: {
    ...makeFields({
      redirectTo: "login/redirectTo",
    }),
  },
};
</script>
